/**
 * Streamline Flex icons (src/assets/svg/icons) used by stat cards.
 *
 * Keyed by the *kind* of metric rather than by page, so the same metric always
 * carries the same icon — "Session Time" on a dashboard and on a user's
 * profile can never drift apart — and swapping an icon is a one-line change
 * here that lands everywhere.
 *
 * The icons ship as flat `#000000` strokes, so they are rendered with <img>
 * and flipped for dark mode with `dark:invert` (see IconBadge).
 */
import alarmClockIcon from '../../../assets/svg/icons/Alarm-Clock--Streamline-Flex.svg';
import userGroupIcon from '../../../assets/svg/icons/User-Group--Streamline-Flex.svg';
import graphDotIcon from '../../../assets/svg/icons/Graph-Dot--Streamline-Flex.svg';
import calendarMarkIcon from '../../../assets/svg/icons/Calendar-Mark--Streamline-Flex.svg';
import openFolderIcon from '../../../assets/svg/icons/Open-Folder--Streamline-Flex.svg';
import chatBubbleIcon from '../../../assets/svg/icons/Chat-Bubble-Text-Oval--Streamline-Flex.svg';
import aiSparkIcon from '../../../assets/svg/icons/Ai-Spark-Starlight--Streamline-Flex.svg';
import targetIcon from '../../../assets/svg/icons/Target--Streamline-Flex.svg';
import checkIcon from '../../../assets/svg/icons/Check--Streamline-Flex.svg';
import checklistIcon from '../../../assets/svg/icons/List-To-Do-Tasks-Checklist--Streamline-Flex.svg';
import fileReportIcon from '../../../assets/svg/icons/File-Report--Streamline-Flex.svg';
import pencilIcon from '../../../assets/svg/icons/Pencil--Streamline-Flex.svg';
import chairIcon from '../../../assets/svg/icons/Chair--Streamline-Flex.svg';
import onlineStatusIcon from '../../../assets/svg/icons/Online-Status-Active-Account--Streamline-Flex.svg';
import addCircleIcon from '../../../assets/svg/icons/Add-Circle--Streamline-Flex.svg';
import cursorClickIcon from '../../../assets/svg/icons/Cursor-Click--Streamline-Flex.svg';
import companyIcon from '../../../assets/svg/icons/Company--Streamline-Flex.svg';
import partnerIcon from '../../../assets/svg/icons/Partner--Streamline-Flex.svg';
import revenueIcon from '../../../assets/svg/icons/Revenue--Streamline-Flex.svg';
import subscriptionIcon from '../../../assets/svg/icons/Subscription--Streamline-Flex.svg';
import specialistIcon from '../../../assets/svg/icons/Specialist--Streamline-Flex.svg';
import sessionIcon from '../../../assets/svg/icons/Session--Streamline-Flex.svg';

export const STAT_ICONS = {
  // Activity
  sessions: graphDotIcon,
  logs: fileReportIcon,
  completions: targetIcon,
  time: alarmClockIcon,
  streak: calendarMarkIcon,

  // People
  users: userGroupIcon,
  activeUsers: checkIcon, // the "active subset" of a population
  wearable: checkIcon, // connected / not connected
  onlineNow: onlineStatusIcon, // people currently/recently active
  newUsers: addCircleIcon, // joiners added to a population
  seats: chairIcon, // licence capacity, filled or empty

  // Content
  audioLibrary: openFolderIcon,
  catalog: checklistIcon,
  plays: chatBubbleIcon,
  rating: aiSparkIcon,
  custom: pencilIcon,

  // Outcomes
  personalBest: targetIcon,
  score: targetIcon,
  goals: checklistIcon,

  // Navigation
  more: cursorClickIcon, // "see the rest of this group"

  // Platform. Only the super-admin panel has a population made of companies
  // rather than people, so these have no company-panel equivalent.
  company: companyIcon, // a B2B customer, as an organisation
  partner: partnerIcon, // an introducer, not a customer
  revenue: revenueIcon,
  subscription: subscriptionIcon, // plans, renewals, seats bought
  specialist: specialistIcon, // a PEAP practitioner
  session: sessionIcon // a booked appointment between the two
};

export default STAT_ICONS;
